import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getIkeaProducts } from "../services/mapServices";
import { useState } from "react";

export function useProduct() {
  const [param, setParam] = useState(null);
  const product = useQuery({
    queryKey: ["products", param],
    queryFn: () => getIkeaProducts(param),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !!param,
  });
  const getProduct = (ref) => {
    setParam(ref);
  };

  return {
    product: product.data || null,
    isLoadingProduct: product.isLoading,
    getProduct,
  };
}
